import { useEffect } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

export function Modal({ open, onClose, className = "", title, subtitle, children, footer, testId }) {
  useEffect(() => {
    const h = (e) => e.key === "Escape" && onClose?.();
    if (open) window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [open, onClose]);

  if (!open) return null;
  return createPortal(
    <div className="rj-modal-overlay" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose?.(); }}>
      <div className={`rj-modal ${className}`} role="dialog" aria-modal="true" data-testid={testId}>
        {(title || onClose) && (
          <div className="rj-modal-head">
            <div>
              {title && <h3>{title}</h3>}
              {subtitle && <p>{subtitle}</p>}
            </div>
            {onClose && (
              <button className="rj-modal-close" onClick={onClose} data-testid="modal-close" aria-label="Tutup">
                <X size={18} />
              </button>
            )}
          </div>
        )}
        {children}
        {footer && <div className="rj-modal-foot">{footer}</div>}
      </div>
    </div>,
    document.body
  );
}
